import { useEffect, useState } from "react";
import { Typography } from "@mui/material";

const WwImage = (props) => {
  let [classnames, setClassnames] = useState('');
  let [alignClass, setAlignClass] = useState('');
  //let [classnames, setClassnames] = useState('');
  
  useEffect(() => {
    console.log(":::::::",props.data);
    if (
        props.data.style.decoration_classes !== null &&
        props.data.style.decoration_classes !== undefined
    ) {
        setClassnames(props.data.style.decoration_classes.join(" "));
    }

    //setClassnames(classnames + " slideInLeft q-pa-xs");

    if (
        props.data.style.align !== null &&
        props.data.style.align !== undefined
    ) {
        setAlignClass(props.data.style.align);
    } else {
        setAlignClass("");
    }

  },[props.data])

  return (
    <>
      {props.data && props.data.source && (
        <div className={classnames} style={{textAlign : alignClass, margin: '5px',borderRadius:'5px', width: 'inherit'}}>
                <img
                    id={props.data.myId.self}
                    className={classnames}
                    src={`${sessionStorage.getItem('media_url')}image/${props.data.source}`}
                    width={!props.data.style.width ? '70%' : (props.data.style.width=='100%') ? props.data.style.objectFit == 'fill' ? '100%' : '70%' : props.data.style.width == '75%' ? '70%' : props.data.style.width}
                    height={props.data.style.height}
                    style={{textAlign: alignClass, display: props.initHide && props.initHide.indexOf(props.data.myId.self) > -1 ? 'none' : 'inline-block'}}
                />
            </div>
      )}
    </>
  );
};

export default WwImage;
